export const JOB_OFFER = 'job-offer';
export const SERVICE = 'service';
export const DEVELOPMENT = 'development';
export const DESIGN = 'design';

export const DEVELOPMENT_AND_DESIGN = Object.freeze([DEVELOPMENT, DESIGN]);

export const DEFAULT_EMAIL_CONTENT = Object.freeze({
  name: '',
  email: '',
  inquiry_type: '',
  job_position: '',
  company: '',
  service_type: '',
  package_type: '',
  message: ''
});